import { TYPE_FAMILIES, TYPE_SCALE } from '../data/typography';

export function TypographySection() {
  return (
    <div className="space-y-6">
      {/* Font families */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {TYPE_FAMILIES.map((f) => (
          <div key={f.name} className="border rounded-lg p-5 bg-white">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
              {f.role}
            </div>
            <div
              className="text-4xl text-slate-900"
              style={{ fontFamily: `'${f.name}', system-ui, sans-serif`, fontWeight: f.name === 'Work Sans' ? 300 : 400 }}
            >
              {f.name}
            </div>
            <p className="text-xs text-slate-500 mt-2">{f.notes}</p>
          </div>
        ))}
      </div>

      {/* Type scale */}
      <div className="border rounded-lg overflow-hidden bg-white">
        <div className="px-4 py-2 bg-slate-50 border-b text-xs font-semibold uppercase tracking-wide text-slate-600">
          Type scale
        </div>
        <div className="divide-y">
          {TYPE_SCALE.map((t) => (
            <div key={t.element} className="flex flex-col md:flex-row md:items-center gap-3 p-4">
              <div className="md:w-48 shrink-0">
                <div className="text-sm font-medium text-slate-900">{t.element}</div>
                <div className="text-[11px] text-slate-500">
                  {t.font} · {t.sizePx}px · {t.weight} · {t.case}
                </div>
              </div>
              <div
                className="flex-1 text-slate-900"
                style={{
                  fontFamily: `'${t.font}', system-ui, sans-serif`,
                  fontSize: `${t.sizePx}px`,
                  fontWeight: t.weight,
                  textTransform: t.case === 'uppercase' ? 'uppercase' : 'none',
                  lineHeight: 1.2,
                }}
              >
                {t.sample}
              </div>
            </div>
          ))}
        </div>
      </div>

      <p className="text-xs text-slate-500">
        Fonts loaded via Google Fonts in <code className="px-1 rounded bg-slate-100">apps/frontend-react/index.html</code>.
      </p>
    </div>
  );
}
